import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ManagementPhotoPreviewService } from '../shared/management-photo-preview.service';

@Injectable({ providedIn: 'root' })
export class ActivitiesManagementPhotoService extends ManagementPhotoPreviewService {
  constructor(@Inject(DOCUMENT) document: Document) {
    super(document);
  }
}
